<template>
  <div class="trapezoid btn-like" :style="styleObj" @mouseenter="isHover = true" @mouseleave="isHover = false">
    <slot></slot>
  </div>
</template>

<script>
import imgBg from './imgs/btn-trapezoid-bg.png'
import imgBgHover from './imgs/btn-trapezoid-bg-hover.png'

export default {
  data() {
    return {
      isHover: false,
    }
  },
  computed: {
    styleObj() {
      return {
        'background-image': `url(${this.isHover ? imgBgHover : imgBg})`,
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.trapezoid {
  display: inline-block;
  padding: 0 12px;

  background-size: 100% 100%;
  background-repeat: no-repeat;

  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;

  line-height: 25px;
}
.btn-like {
  cursor: pointer;
}
</style>
